var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHot = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23615_25132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5257 1.80001C13.3818 1.51921 13.1633 1.28355 12.8941 1.119C12.6249 0.954443 12.3155 0.867371 12 0.867371C11.6845 0.867371 11.3751 0.954443 11.1059 1.119C10.8367 1.28355 10.6181 1.51921 10.4743 1.80001L1.04569 20.6572C0.914186 20.9181 0.851577 21.2084 0.863807 21.5003C0.876037 21.7923 0.962701 22.0763 1.11557 22.3254C1.26844 22.5744 1.48243 22.7803 1.73723 22.9233C1.99203 23.0664 2.27918 23.142 2.5714 23.1429H21.4285C21.7208 23.142 22.0079 23.0664 22.2627 22.9233C22.5175 22.7803 22.7315 22.5744 22.8844 22.3254C23.0372 22.0763 23.1239 21.7923 23.1361 21.5003C23.1484 21.2084 23.0858 20.9181 22.9543 20.6572L13.5257 1.80001Z",
    fill: "#FFF6A2",
    stroke: "#EE2D24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.57143V13.7143",
    stroke: "#EE2D24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.7143C12.4734 19.7143 12.8571 19.3305 12.8571 18.8571C12.8571 18.3838 12.4734 18 12 18C11.5266 18 11.1428 18.3838 11.1428 18.8571C11.1428 19.3305 11.5266 19.7143 12 19.7143Z",
    stroke: "#EE2D24",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23615_25132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHot, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hot.fde0f7f6.svg";
export { ForwardRef as ReactComponent };